import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Checkbox,
  Radio,
  TextField,
  FormControlLabel,
  FormControl,
  RadioGroup,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./index.scss";
import {
  AIR_FILTER_ACCORDION_TABS_QUESTIONS,
  getAirFilterQuestions,
  getTurbochargerQuestions,
  isSelected,
  mappingDetailsToUI,
} from "./air-system-helper";

const AirSystem = ({ data }) => {
  const [details, setDetails] = useState({});
  const [expanded, setExpanded] = useState("");

  useEffect(() => {
    if (data) {
      setDetails(mappingDetailsToUI(data));
    }
  }, [data]);

  const handleAccordionChange = (panel) => {
    setExpanded(expanded === panel ? "" : panel);
  };

  const getQuestions = (key) => {
    if (key === "Air Intake & Exhaust System") {
      return getAirFilterQuestions(details);
    } else if (key === "Aspiration") {
      return getTurbochargerQuestions(details);
    }

    return AIR_FILTER_ACCORDION_TABS_QUESTIONS[key] || [];
  };

  return (
    <Box className="air-system-container">
      <Typography variant="h5" className="header" gutterBottom>
        Air System Details
      </Typography>
      {Object.keys(AIR_FILTER_ACCORDION_TABS_QUESTIONS).map((key) => (
        <Accordion
          key={key}
          expanded={expanded === key}
          onChange={() => handleAccordionChange(key)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`${key}-content`}
            id={`${key}-header`}
          >
            <Typography variant="h6">{key}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {getQuestions(key)?.map((item, index) => {
              return (
                <Box key={index} className="detail-item" mb={2}>
                  <Typography variant="subtitle1">
                    {index + 1}. {item.label}
                  </Typography>
                  <Box className="detail-options">
                    {item.type === "DATE" && (
                      <Typography variant="body2" color="text.secondary">
                        Date:{" "}
                        {(details[item.apiKey] &&
                          new Date(details[item.apiKey]).toLocaleDateString(
                            "en-GB"
                          )) ||
                          "N/A"}
                      </Typography>
                    )}
                    {item.type === "INPUT" && (
                      <Box className="input-container">
                        <TextField
                          value={details[item.apiKey] || ""}
                          variant="outlined"
                          size="small"
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </Box>
                    )}

                    {item.type === "RADIO" && (
                      <FormControl>
                        <RadioGroup row value={details[item.apiKey]}>
                          {item.options?.map((option, optIndex) => (
                            <FormControlLabel
                              key={optIndex}
                              value={option.label}
                              control={
                                <Radio
                                  checked={
                                    details[item.apiKey] === option.label
                                  }
                                />
                              }
                              label={option.label}
                            />
                          ))}
                        </RadioGroup>
                      </FormControl>
                    )}

                    {item.options &&
                      item.type !== "RADIO" &&
                      item.options.map((option, optIndex) => {
                        return (
                          <FormControlLabel
                            key={optIndex}
                            control={
                              <Checkbox
                                checked={
                                  isSelected(details, item, option) || false
                                }
                                readOnly
                              />
                            }
                            label={option.label}
                          />
                        );
                      })}
                  </Box>
                </Box>
              );
            })}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default AirSystem;
